import { geditPayUnlockMixin } from '../../../mixins/geditPayUnlock.js';
import { GEDIT_GLOBAL_PAY_OID } from '../../../utils/geditPay.js';
import { getButtonStyle } from './utils.js';

export const payUnlockMixin = {
	mixins: [geditPayUnlockMixin],
	props: {
		data: {
			type: Object,
			required: true,
		},
		blockId: {
			type: String,
			default: '',
		},
		editable: {
			type: Boolean,
			default: false,
		},
		active: {
			type: Boolean,
			default: false,
		},
		fixedBottom: {
			type: Boolean,
			default: false,
		},
		h5: {
			type: Boolean,
			default: false,
		},
	},
	emits: ['select'],
	computed: {
		buttonStyle() {
			return getButtonStyle(this.data, this.defaultButtonColors || {});
		},
		/** 当前全局支付组件是否启用了"隐藏其他付费组件价格" */
		hideOtherPrice() {
			return Boolean(this.data?.hideOtherPrice);
		},
		/**
		 * JumpLink 系列（付费跳转组件）是独立的内容付费模块，每个有独立 o_id，
		 * 不能用「未解锁内容模块全部付清」的全局支付条逻辑去判断（否则某模块已付、
		 * 其他模块未付时，会被错误标记为未支付）。
		 * 判断依据：组件名以 GBlockPayUnlockJumpLink 开头的 8 种组件。
		 */
		isJumpLinkFamilyBlock() {
			const name = this.$options?.name || '';
			return name.startsWith('GBlockPayUnlockJumpLink');
		},
		/** 独立模块已支付：仅看自己 o_id；全局支付条：未解锁内容模块全付清才算 */
		isGeditModulePaid() {
			if (this.isJumpLinkFamilyBlock) {
				return Boolean(this.geditPay?.paidModules?.[this.blockId]);
			}
			const unpaid = this.geditPay?.getUnpaidModuleOIds?.();
			if (Array.isArray(unpaid)) {
				return unpaid.length === 0;
			}
			return Boolean(this.geditPay?.paidModules?.[this.blockId]);
		},
	},
	methods: {
		onWrapClick(e) {
			if (!this.editable) {
				if (this.h5) {
					this.onButtonClick(e);
				}
				return;
			}
			e?.stopPropagation?.();
			this.$emit('select');
		},
		onButtonClick(e) {
			if (this.editable) {
				e?.stopPropagation?.();
				this.$emit('select');
				return;
			}
			this.runGlobalUnlockFlow();
		},
		runGlobalUnlockFlow() {
			if (this.editable) return;
			if (!this.isGeditRealPay) {
				return;
			}
			const unpaid = this.geditPay?.getUnpaidModuleOIds?.() || [];
			if (!unpaid.length) return;
			// 全局支付下单 o_id 固定传 100（后端据此识别"全站解锁"，不再拼接模块 id）
			const oId = GEDIT_GLOBAL_PAY_OID;
			const requestPay = this.geditPay?.requestPay;
			if (typeof requestPay !== 'function') return;
			Promise.resolve(requestPay(oId)).catch(() => {});
		},
	},
};
